import { render, staticRenderFns } from "./DaftarClient.vue?vue&type=template&id=323e47f8"
import script from "./DaftarClient.vue?vue&type=script&lang=js"
export * from "./DaftarClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports